module.exports = __webpack_public_path__ + "static/media/clovers.3e3bbf6d.svg";